import {
  ComponentType,
  PropsWithChildren,
  ReactElement,
  ReactNode,
} from 'react';

import {
  withProps,
  InfoTooltip,
  Typography,
  Box,
  Stack,
  tokens,
} from '@cast/design-system';

import { CardFormControl } from '../../../../_components/CardFormControl';

import type { TypographyProps } from '@cast/design-system';

const DefaultText = withProps(Typography, {
  variant: 'P12R',
  children: '(default)',
  sx: {
    color: tokens.theme.fg.structural.secondary,
    fontStyle: 'italic',
  },
});

export const PolicyCardForm = ({
  label,
  description,
  isDefault,
  labelProps,
  tooltipText,
  badge,
  control,
  LabelComponent,
}: {
  label: string;
  description?: string | null;
  isDefault?: boolean;
  labelProps?: TypographyProps;
  tooltipText?: ReactNode;
  badge?: ReactNode;
  control: ReactElement;
  LabelComponent?: ComponentType<PropsWithChildren>;
}) => {
  const labelVariant: TypographyProps['variant'] = 'P12M';

  const descriptionVariant: TypographyProps['variant'] = 'P12R';

  const tooltip = tooltipText && (
    <InfoTooltip
      title={tooltipText}
      iconSize="15px"
      iconSx={{ marginLeft: '3px', verticalAlign: 'middle' }}
    />
  );

  const { sx: labelSx, ...restLabelProps } = labelProps ?? {};
  const Label = LabelComponent ?? (({ children }) => <>{children}</>);

  return (
    <CardFormControl
      control={control}
      label={
        <Stack>
          <Stack direction="row" gap={4} alignItems="center">
            <Label>
              <Typography
                variant={labelVariant}
                {...restLabelProps}
                sx={[
                  { color: tokens.theme.fg.structural.primary },
                  ...(Array.isArray(labelSx)
                    ? labelSx
                    : labelSx
                    ? [labelSx]
                    : []),
                ]}
              >
                {label}
              </Typography>
            </Label>
            {badge && <Box>{badge}</Box>}
            {isDefault && <DefaultText />}
            {tooltip}
          </Stack>
          {description && (
            <Typography
              variant={descriptionVariant}
              sx={{ color: tokens.theme.fg.structural.secondary }}
            >
              {description}
            </Typography>
          )}
        </Stack>
      }
      sx={{ py: 12, alignItems: 'flex-start' }}
    />
  );
};
